import { render, staticRenderFns } from "./newscenter.vue?vue&type=template&id=3abc10a0&scoped=true&"
import script from "./newscenter.vue?vue&type=script&lang=js&"
export * from "./newscenter.vue?vue&type=script&lang=js&"
import style0 from "./newscenter.vue?vue&type=style&index=0&id=3abc10a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abc10a0",
  null
  
)

export default component.exports